import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { UserRoleType } from '../../models/User';
import ProcessBarItem, { ProcessBarTag } from '../../models/ProcessBarItem';

import barItems from '../../configs/processBarItems';

import processBarStyles from './processBar.module.css';

interface ProcessBarProps {
  cartItems: number;
  type: string;
  dropOffItems: number;
  userRole: UserRoleType;
  isMeEditMode: boolean;
};

const processBar = (props: ProcessBarProps) => {

  const items: number = props.type === 'import' ? props.cartItems : props.dropOffItems;
  const activeClassName = (props.type==='offline') ? processBarStyles.offlineActive : processBarStyles.active;
  const getProcessBarItems = (): Array<ProcessBarItem> => {

    const orderType: string = props.type;

    if (props.userRole === UserRoleType.GHA) {

      if (orderType === 'offline') {
        return barItems.barItems.offline;
      } else {
        if (orderType === 'import') {

          return barItems.barItems.ghaImport;

        } else {

          return barItems.barItems.ghaExport.filter((barItem: ProcessBarItem) => {

            if (props.isMeEditMode) {
              return barItem.tag !== ProcessBarTag.CART;
            }

            if(props.userRole == UserRoleType.FORWARDER) {
              return barItem.tag !== ProcessBarTag.ORDER;
            }
            
            return barItem
          });
        }
      }

    } else {
      if(orderType === 'import') {
        return barItems.barItems.import.filter((barItem: ProcessBarItem) => {
            return barItem.tag !== ProcessBarTag.ORDER;
        });
      } else {
        return barItems.barItems.export; 
      }
    }
  }

  return (
    
    <div className={processBarStyles.processBarWrapper}>
      {
        getProcessBarItems().map((item, index) => {
          return <Link key={ index } to={ item.link } className={processBarStyles.processBarLink}>
            <hr className={ `${processBarStyles.hr} ${processBarStyles.hrItem} ${index === 0? processBarStyles.hrInvisible : ''}` }/>
            <div className={processBarStyles.stepWrapper}>
              <div className={processBarStyles.imageWrapper}>
                <hr className={ `${processBarStyles.hr} ${processBarStyles.hrIcon} ${index === 0? processBarStyles.hrInvisible : ''}` }/>
                <div className={processBarStyles.cartItemsWrapper}>
                  <img src={location.pathname.split('/')[1] === item.link? item.activeIcon : item.icon} alt={item.label}/>
                  { (index === 1 && items > 0) && <div className={ processBarStyles.cartAmount }>{ items }</div> }
                </div>
                <hr className={ `${processBarStyles.hr} ${processBarStyles.hrIcon} ${index === (getProcessBarItems().length - 1) ? processBarStyles.hrInvisible : ''}` }/>
              </div>
              <div className={processBarStyles.textHide}><div className={location.pathname.split('/')[1] === item.link? activeClassName : ''}>{item.label}</div></div>
            </div>
            <hr className={ `${processBarStyles.hr} ${processBarStyles.hrItem} ${index === (getProcessBarItems().length - 1) ? processBarStyles.hrInvisible : ''}` }/>
          </Link>
        })
      }
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    isMeEditMode: state.manualEntryEdit.isEditMode
  };
}
  
export default connect(mapStateToProps, {})(processBar);
